import type { Reducer } from 'redux';

import { getGraphqlApiErrorReason } from '../..';
import type { EventRestrictedPostingUpdateAction } from '../../domains/eventRestrictedPosting/actions.types';
import type { PublishEventMessageRejectedAction } from '../../domains/publishers/actions.types';
import type { RestrictedPostingAcceptanceUpdateAction } from '../../domains/restrictedPostingAcceptance/actions.types';

import type { RestrictedPostingChangeAcceptance } from './types';

export type RestrictedPostingAction =
  | RestrictedPostingAcceptanceUpdateAction
  | EventRestrictedPostingUpdateAction
  | PublishEventMessageRejectedAction;

const initialState: RestrictedPostingChangeAcceptance = { requiresUserAcceptance: false };

const reducer: Reducer<RestrictedPostingChangeAcceptance, RestrictedPostingAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'RESTRICTED_POSTING_ACCEPTANCE.RESET':
      return { requiresUserAcceptance: false };
    case 'EVENT.UPDATE_RESTRICTED_POSTING':
      return { requiresUserAcceptance: action.payload.isUserAcceptanceRequired };
    case 'PUBLISHER.PUBLISH_EVENT_MESSAGE_REJECTED':
      if (getGraphqlApiErrorReason(action.payload.error) === 'RESTRICTED_POSTING_IN_EVENT') {
        return { requiresUserAcceptance: true };
      }

      return state;
    default:
      return state;
  }
};

export default reducer;
